import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.franchisee.view.FranchiseePaymentProfileDetailView.';
  public static readonly pleaseSelectSupplier = `${Id.prefix}pleaseSelectSupplier`;
  public static readonly caption = `${Id.prefix}caption`;
  public static readonly supplierDescription = `${Id.prefix}supplierDescription`;
  public static readonly supplierTitle = `${Id.prefix}supplierTitle`;
  public static readonly paymentProfileTitle = `${Id.prefix}paymentProfileTitle`;
  public static readonly calculationTitle = `${Id.prefix}calculationTitle`;
  public static readonly quoteTermsAndConditions = `${Id.prefix}quoteTermsAndConditions`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangFranchiseePaymentProfileDetailView {
  private constructor() {}
  public static pleaseSelectSupplier(): string {
    return interpolate(Id.pleaseSelectSupplier);
  }
  public static caption(): string {
    return interpolate(Id.caption);
  }
  public static supplierDescription(params: { description: string }): string {
    return interpolate(Id.supplierDescription, params);
  }
  public static supplierTitle(): string {
    return interpolate(Id.supplierTitle);
  }
  public static paymentProfileTitle(): string {
    return interpolate(Id.paymentProfileTitle);
  }
  public static calculationTitle(): string {
    return interpolate(Id.calculationTitle);
  }
  public static quoteTermsAndConditions(): string {
    return interpolate(Id.quoteTermsAndConditions);
  }
}

export class FranchiseePaymentProfileDetailViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.pleaseSelectSupplier,
      "Please Select a {{glossary 'supplier'}}.",
      'Validation error for missing supplier'
    );
    register.add(Id.caption, '', 'Caption for Franchisee Payment Profile Detail View');
    register.add(Id.supplierDescription, '{{description}}', 'Supplier description in dropdown');
    register.add(Id.supplierTitle, "{{glossary 'supplier'}}", 'Supplier selector title');
    register.add(Id.paymentProfileTitle, "{{glossary 'payment-profile'}}", 'Payment profile field label');
    register.add(Id.calculationTitle, 'Calculation', 'Calculation radio group label');
    register.add(
      Id.quoteTermsAndConditions,
      "{{glossary 'quote'}} Terms and Conditions",
      'Note for quote terms and conditions'
    );
  }
}
